const CardMedia = {
  defaultProps: {},
  styleOverrides: {
    root: () => ({
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
    }),
  },
};

export default CardMedia;
